import { createConnectQueryKey, useMutation, useQuery } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import {
  getPortalReminderSetting,
  getSlackUserDmLink,
  getUserAssignments,
  isUserSubscribedToTenant,
  listSlackChannels,
  setPortalReminderSetting,
  updateUserTenantSubscription,
} from '@/gen/notifications/v1/notifications_service-NotificationsService_connectquery'

import { defaultTransport } from '@/lib/connect/connect-transport'

export const isUserSubscribedToTenantQueryKey = createConnectQueryKey({
  schema: isUserSubscribedToTenant,
  input: {},
  cardinality: 'finite',
  transport: defaultTransport,
})

export const useGetSlackUserDmLink = () => useMutation(getSlackUserDmLink)

export const useListSlackChannels = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const queryState = useQuery(listSlackChannels, {}, { enabled })
  return {
    ...queryState,
    data: queryState.data?.channels || [],
  }
}

export const useIsUserSubscribedToTenant = () => {
  const queryState = useQuery(isUserSubscribedToTenant)
  return {
    ...queryState,
    data: queryState.data?.isSubscribed,
  }
}

export const useGetUserAssignments = () => {
  const queryState = useQuery(getUserAssignments)
  return {
    ...queryState,
    thirdParties: queryState.data?.thirdParties || [],
    projects: queryState.data?.projects || [],
    assessments: queryState.data?.assessments || [],
  }
}

export const useUpdateUserTenantSubscription = () => {
  const queryClient = useQueryClient()

  return useMutation(updateUserTenantSubscription, {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: isUserSubscribedToTenantQueryKey })
    },
  })
}

const portalReminderSettingQueryKey = createConnectQueryKey({
  schema: getPortalReminderSetting,
  input: {},
  cardinality: 'finite',
  transport: defaultTransport,
})

export const useGetPortalReminderSetting = () => {
  const queryState = useQuery(getPortalReminderSetting)
  return {
    ...queryState,
    data: queryState.data,
  }
}

export const useSetPortalReminderSetting = () => {
  const queryClient = useQueryClient()

  return useMutation(setPortalReminderSetting, {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: portalReminderSettingQueryKey })
    },
  })
}
